export enum CallbackTaskCommandTypes {
    CreateSfnCallbackTask = 'CallbackService.Command.CreateSfnCallbackTask',
    HandleCallbackTask = 'CallbackService.Command.HandleCallbackTask'
}
